<template>
    <div id="votePopover">
        <v-popover :open="open" :auto-hide="false" placement="bottom-start">
            <template slot="popover">
                <h5>Vote for good or bad</h5>
                <p>
                    Show your appreciation by upvoting valuable answers.
                    Downvote pushes not helpful answers down the list.
                </p>

                <button class="btn btnRed btnSm" @click="close">
                    Ok, got it!
                </button>
            </template>
        </v-popover>
    </div>
</template>

<script>
    import BasePopover from './BasePopover'
    import { VPopover } from "v-tooltip"

    export default {
        name: 'VotePopover',
        extends: BasePopover,
        components: {
            VPopover
        }
    }
</script>